import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-secondary text-white py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
          <div className="text-sm text-white/70">
            &copy; 2024 rack51. All rights reserved.
          </div>
          
          <div className="flex items-center space-x-6 text-sm">
            <a 
              href="/legal/terms" 
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Terms of Service
            </a>
            <a 
              href="/legal/privacy" 
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
